export const GET_ENGAGEMENT_SUCCESS = '[SERVICEINIT][ADDINITIATION] get engagement succeeded';
export const GET_INITIATIONTYPE_SUCCESS = '[SERVICEINIT][ADDINITIATION] get initiation type succeeded';
export const GET_SERVICETYPE_SUCCESS = '[SERVICEINIT][ADDINITIATION] get service type succeeded';
export const SET_ADDINITIATION_VALUE = '[SERVICEINIT][ADDINITIATION] set add initiation value';
export const GET_COUNTRYLIST_SUCCESS = '[SERVICEINIT][ADDINITIATION] get country list succeeded';
export const GET_PASSPORT_COUNTRYLIST_SUCCESS = '[SERVICEINIT][ADDINITIATION] get passport country list succeeded';
export const GET_PASSPORT_RELATIONSHIPSTATUS_SUCCESS = '[SERVICEINIT][ADDINITIATION] get relationship status list succeeded';
export const GET_EMPLOYEETYPELIST_SUCCESS = '[SERVICEINIT][ADDINITIATION] get employee type list succeeded';
export const GET_SISHOWORGANIZER_SUCCESS = '[SERVICEINIT][DYNAMICCONTENT] get show organizer data succeeded';
export const GET_SI_CHANGEPAGE = '[SERVICEINIT][ADDINITIATION] change page';
export const RESET_DYNAMIC_CONTENT = '[SERVICEINIT][ADDINITIATION] reset dynamic content';
export const RESET_DYNAMIC_FORMVALUES = '[SERVICEINIT][ADDINITIATION] reset dynamic form values';
export const RESUME_INITIATION_SUCCESS = '[SERVICEINIT][ADDINITIATION] resume add initiation success';
export const RESET_INITIATION = '[SERVICEINIT][ADDINITIATION] reset initiation';
export const CREATE_ORGANIZER_SUCCESS = '[SERVICEINIT][ADDINITIATION] create show organizer succeeded';
export const CREATE_NEWEMPLOYEE_FAILURE = '[SERVICEINIT][ADDINITIATION] create new employee failure';
export const CREATE_NEWEMPLOYEE_SUCCESS = '[SERVICEINIT][ADDINITIATION] create new employee success';
export const SSI_SHOW_LOADING = '[SERVICEINIT] show loading';
export const SSI_HIDE_LOADING = '[SERVICEINIT] hide loading';
export const GET_FILTERS_SUCCESS = '[SERVICEINIT] get filters success';
export const SHOW_FILTER_MODAL = '[SERVICEINIT] show filter modal';
export const RESET_EMPLOYEE = '[SERVICEINIT][ADDINITIATION] reset employee data';
export const UPDATE_MENU = '[SERVICEINIT][ADDINITIATION] update menu';
export const SET_MANUAL_INITIATION = '[SERVICEINIT][ADDINITIATION] set manual initiation';
export const SET_BATCH_INITIATION_LOADING = '[SERVICEINIT][ADDINITIATION] set batch initiation loading';
export const SET_BATCH_INITIATION_COMPLETE = '[SERVICEINIT][ADDINITIATION] set batch initiation complete';
export const SET_NEXT_DISABLED = '[SERVICEINIT][ADDINITIATION] set next button disabled';
export const SET_NEXT_ENABLED = '[SERVICEINIT][ADDINITIATION] set next button enabled';



// WEBPACK FOOTER //
// ./src/ui/features/ServiceInit/state/serviceInitTypes.js